import React from 'react';
import PropTypes from 'prop-types';

import ModalButton from './ModalButton';
import PopoverButton from './PopoverButton';

function SelectItemTableCodes({ type }) {
  return (
    <>
      { type === 'modal'
        ? (
          <ModalButton />
        )
        : (
          <PopoverButton />
        )}
    </>
  );
}

SelectItemTableCodes.propTypes = {
  type: PropTypes.oneOf(['modal', 'popover']).isRequired
};

export default SelectItemTableCodes;
